import i18n from '@/lang/i18n'
import { initialScientificAnalysisRenameModalState, ScientificAnalysisRenameModalState } from '@/modules/scientific-analysis-module/components/scientific-analysis-rename-modal/scientific-analysis-rename-modal.models'
import { scientificAnalysisService, ScientificAnalysisService } from '@/modules/scientific-analysis-module/services/scientific-analysis-services'
import { Vue, Component, Ref } from 'vue-property-decorator'

@Component
export default class ScientificAnalysisRenameModal extends Vue {
    @Ref() readonly scientificAnalysisRenameModal!: any
    state:ScientificAnalysisRenameModalState
    service: ScientificAnalysisService = scientificAnalysisService

    constructor() {
        super()
        this.state = initialScientificAnalysisRenameModalState()
    }

    show(templateId:number, currentName:string):void {
        this.scientificAnalysisRenameModal.show()
        this.state.templateId = templateId
        this.state.oldName = currentName
        this.state.name = currentName
    }

    hide():void { this.scientificAnalysisRenameModal.hide() }

    async _onRenameClick():Promise<void> {
        if (this.state.oldName !== this.state.name) {
            const templateHeader = await this.$_toCallSecureLoading(this.service.renameTemplate(this.state.templateId, this.state.name))
            this.$emit('templaterenamed', templateHeader)
            this.$_showToastSuccess(i18n.tc('scientificAnalysis.sidebar.savesuccess'))
        }
        this.hide()
    }
}
